import api from "../../index";

export const GetAllAccountApi = (params) => api.get(`Withdraw/GetWithdraw-Request?${params}`);
export const RequestAcceptRejectApi = (data) => api.post('WalletMaster/Approved-Reject-Wallet-Withdraw-Request', data);
export const GetAllWithdrawByIdApi = (params) => api.get(`WalletMaster/GetSingle-WithdrawalById?${params}`);
export const RequestRejectApi = (data) => api.post('Withdraw/Reject-Withdraw-Request', data);
